import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Formik } from 'formik'

import { closeModal } from 'store/actions/modals'
import { useProjects } from 'Api'
import { hashTable } from 'services/Utilities'
import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Textarea } from 'components/Forms'

const PasteProjectCodesModal = ({ setSelection }: { setSelection: (name: string, selectedResourcesMap: Record<string, boolean>) => void }) => {
  const { data: projects = [] } = useProjects(data => data.projects)
  const dispatch = useDispatch()
  const { t } = useTranslation('legacy')

  const projectsCodesMap = useMemo(() => hashTable(projects, 'code'), [projects])

  if (!projects) return null

  const parseUserInput = (value: string) => {
    return value.trim().replace(/\n|,/g, ' ').replace(/ +/g, ' ').split(' ')
  }

  const validateProjectCodes = (projectCodes: string): string | void => {
    const parsedProjectCodes = parseUserInput(projectCodes)
    const invalidCodes = parsedProjectCodes
      .map(code => {
        if (!projectsCodesMap[code]) return code
      })
      .filter(Boolean)

    if (!invalidCodes.length) return
    return t(`manager.projects.INVALID_PROJECT_CODES`, { invalidCodes: invalidCodes.join(', ') })
  }

  const onSubmit = ({ projectCodes }: { projectCodes: string }) => {
    const parsedProjectCodes = parseUserInput(projectCodes)

    const selectedProjects: Record<string, boolean> = parsedProjectCodes.reduce((acc, code) => {
      if (projectsCodesMap[code]) acc[projectsCodesMap[code]._id] = true
      return acc
    }, {})

    setSelection('projects', selectedProjects)

    dispatch(closeModal())
  }
  return (
    <BaseModal hideButtons title={`manager.projects.PASTE_PROJECT_CODES`}>
      <Formik onSubmit={onSubmit} enableReinitialize={true} initialValues={{ projectCodes: '' }} validateOnChange={false} validateOnBlur={false}>
        {({ isSubmitting, setFieldValue }) => {
          return (
            <Form>
              <div>
                <Textarea
                  className="mt-3"
                  module="manager.projects"
                  name="projectCodes"
                  validate={validateProjectCodes}
                  style={{ height: '150px' }}
                  onChange={({ target }) => setFieldValue('projectCodes', target.value.trim())}
                />
              </div>

              {/* Submit & Close buttons */}
              <div className="mt-2">
                <Button type="submit" isSubmitting={isSubmitting} text="actions.SUBMIT" className="btn btn-primary mr-2" />
                <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
              </div>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default PasteProjectCodesModal
